import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  ThemeProvider,
} from '@material-ui/core';
import ButtonPrimary from './Button/ButtonPrimary';
import { createTheme } from '@material-ui/core/styles';

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm)
    },
    '@media (min-width:960px)': {
      fontSize: pxToRem(md)
    },
    '@media (min-width:1280px)': {
      fontSize: pxToRem(lg)
    }
  };
}

const theme = createTheme({
  overrides: {
    MuiDialog: {
      paperFullWidth: {
        // border: '2px solid #bf4336',
      }
    },
    MuiTypography: {
      body1: {
        fontFamily: `Kanit-Regular, sans-serif`,
        fontSize: 16,
      },
      h5: {
        fontFamily: `Kanit-Regular, sans-serif`,
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
        ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 })
      }
    }
  }
});

const DialogError = ({
  onClose,
  open,
  title,
  text = 'ไม่สามารถบันทึกข้อมูลได้',
  ...rest
}) => {
  const splitText = text.split('|');

  return (<ThemeProvider theme={theme}>
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth="xs"
      fullWidth
      {...rest}
    >
      <DialogContent>
        <Box mx={2} mt={1}>
          <Box align='center' mb={3}>
            <img alt='' src="/static/images/Error image@2x.png"
              style={{
                width: 300,
                height: 'auto'
              }}
            />
          </Box>

          <Box align="center" mb={1}>
            <Typography variant="h5" style={{ color: '#001D3E' }}>
                {title || 'เกิดข้อผิดพลาด'}
            </Typography>
          </Box>
          <Box align="center">
            {splitText.map((m, i) => (
              <Typography variant='body1' color="textSecondary" key={i}>
                {m}
              </Typography>
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions style={{ display:'flex', justifyContent:'center', marginBottom: 10 }}>
        <Box my={1}>
          <ButtonPrimary
            title={'ตกลง'}
            onClick={onClose}
            style={{ width: 240 }}
          />
        </Box>
      </DialogActions>
    </Dialog>
  </ThemeProvider>)
}

DialogError.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

DialogError.defaultProps = {
  open: false,
  onClose: () => {}
};

export default DialogError;